class BlogCarousel {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.carousel-track');
    this.dotsWrap = el.querySelector('.carousel-dots');
    this.items = this.track.querySelectorAll('.carousel-item:not(.carousel-clone)');
    if (!this.items.length) return;
    this.currentIndex = 0;
    this.autoTimer = null;
    this.isClone = this.track.classList.contains('carousel-track-clone');
    // mouse drag state
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragScrollLeft = 0;
    this.fillClones();
    this.buildDots();
    this.buildArrows();
    this.updateArrows();
    this.bindDrag();
    this.track.addEventListener('scroll', () => this.updateDots());
    window.addEventListener('resize', () => { this.fillClones(); this.buildDots(); this.buildArrows(); this.updateArrows(); this.updateDots(); });
    this.startAutoPlay();
    this.el.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.el.addEventListener('mouseleave', () => this.startAutoPlay());
  }

  getTotal() {
    return this.isClone ? this.items.length : Math.max(1, this.items.length - this.getPerView() + 1);
  }

  startAutoPlay() {
    this.stopAutoPlay();
    this.autoTimer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.getTotal();
      this.scrollTo(this.currentIndex);
    }, 5000);
  }

  stopAutoPlay() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  }

  scrollTo(index) {
    var targetItem = this.items[index];
    if (targetItem) {
      this.track.scrollTo({ left: targetItem.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }
  }

  getPerView() {
    return window.innerWidth <= 749 ? 1 : 3;
  }

  fillClones() {
    if (!this.isClone) return;
    // Remove old clones
    this.track.querySelectorAll('.carousel-clone').forEach(function(c) { c.remove(); });
    var perView = this.getPerView();
    var cloneCount = Math.min(perView - 1, this.items.length - 1);
    for (var i = 0; i < cloneCount; i++) {
      var clone = this.items[i].cloneNode(true);
      clone.classList.add('carousel-clone');
      this.track.appendChild(clone);
    }
  }

  buildDots() {
    this.dotsWrap.innerHTML = '';
    var total = this.getTotal();
    if (window.innerWidth > 749 && total <= 1) {
      this.dotsWrap.style.display = 'none';
      return;
    }
    this.dotsWrap.style.display = '';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', this.onDotClick.bind(this));
      this.dotsWrap.appendChild(dot);
    }
  }

  onDotClick(e) {
    this.currentIndex = parseInt(e.currentTarget.getAttribute('data-index'));
    this.scrollTo(this.currentIndex);
    this.startAutoPlay();
  }

  updateDots() {
    var scrollLeft = this.track.scrollLeft;
    var trackOffset = this.track.offsetLeft;
    var currentIndex = 0;
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].offsetLeft - trackOffset <= scrollLeft + 2) {
        currentIndex = i;
      }
    }
    this.currentIndex = currentIndex;
    var dots = this.dotsWrap.querySelectorAll('.dot');
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === currentIndex);
    });
    this.updateArrows();
  }

  needArrows() {
    var perView = this.getPerView();
    return this.items.length > perView;
  }

  buildArrows() {
    var oldPrev = this.el.querySelector('.carousel-arrow-prev');
    var oldNext = this.el.querySelector('.carousel-arrow-next');
    if (oldPrev) oldPrev.remove();
    if (oldNext) oldNext.remove();
    if (!this.needArrows()) return;
    var self = this;
    var svgLeft = '<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path></svg>';
    var svgRight = '<svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path></svg>';
    var prev = document.createElement('div');
    prev.className = 'carousel-arrow carousel-arrow-prev';
    prev.innerHTML = svgLeft;
    prev.addEventListener('click', function() { if (!this.classList.contains('disabled')) self.prev(); });
    this.el.appendChild(prev);
    var next = document.createElement('div');
    next.className = 'carousel-arrow carousel-arrow-next';
    next.innerHTML = svgRight;
    next.addEventListener('click', function() { if (!this.classList.contains('disabled')) self.next(); });
    this.el.appendChild(next);
  }

  updateArrows() {
    var prev = this.el.querySelector('.carousel-arrow-prev');
    var next = this.el.querySelector('.carousel-arrow-next');
    if (!prev || !next) return;
    var total = this.getTotal();
    prev.classList.toggle('disabled', this.currentIndex <= 0);
    next.classList.toggle('disabled', this.currentIndex >= total - 1);
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollTo(this.currentIndex);
      this.startAutoPlay();
    }
  }

  next() {
    var total = this.getTotal();
    if (this.currentIndex < total - 1) {
      this.currentIndex++;
      this.scrollTo(this.currentIndex);
      this.startAutoPlay();
    }
  }

  bindDrag() {
    var self = this;
    var track = this.track;

    // prevent native drag on images/links inside items
    track.addEventListener('dragstart', function(e) { e.preventDefault(); });

    // prevent text selection during drag on desktop
    if (window.innerWidth > 749) {
      track.querySelectorAll('.carousel-item').forEach(function(item) {
        item.style.userSelect = 'none';
        item.style.webkitUserDrag = 'none';
      });
    }

    track.addEventListener('mousedown', function(e) {
      self.isDragging = true;
      self.dragStartX = e.pageX - track.offsetLeft;
      self.dragScrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
    });

    track.addEventListener('mousemove', function(e) {
      if (!self.isDragging) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - self.dragStartX) * 1.5;
      track.scrollLeft = self.dragScrollLeft - walk;
    });

    var endDrag = function() {
      if (!self.isDragging) return;
      self.isDragging = false;
      track.style.cursor = '';
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      // snap to closest item
      self.snapToNearest();
    };

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', function() {
      if (self.isDragging) endDrag();
    });
  }

  snapToNearest() {
    var scrollLeft = this.track.scrollLeft;
    var trackOffset = this.track.offsetLeft;
    var closest = 0;
    var minDist = Infinity;
    for (var i = 0; i < this.items.length; i++) {
      var dist = Math.abs(this.items[i].offsetLeft - trackOffset - scrollLeft);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    }
    this.currentIndex = closest;
    this.scrollTo(this.currentIndex);
  }
}

document.querySelectorAll('article .article__content .product-carousel').forEach(function(el) {
  new BlogCarousel(el);
});

/* 博客TOC收起展开 */
document.querySelectorAll('article .article__content').forEach(function(content) {
  var h2s = content.querySelectorAll('h2');
  h2s.forEach(function(h2) {
    if (h2.textContent.trim().toLowerCase() === 'table of contents') {
      var ol = h2.nextElementSibling;
      if (ol && ol.tagName === 'OL') {
        var wrapper = document.createElement('div');
        wrapper.className = 'blog-toc';
        h2.parentNode.insertBefore(wrapper, h2);
        wrapper.appendChild(h2);
        wrapper.appendChild(ol);
        h2.classList.add('blog-toc__title');
        h2.addEventListener('click', function() {
          wrapper.classList.toggle('collapsed');
        });
      }
    }
  });
});

/* 博客FAQ手风琴 */
document.querySelectorAll('article .article__content .blog-faq').forEach(function(faq) {
  var children = Array.from(faq.children);
  var items = [];
  var current = null;

  children.forEach(function(child) {
    if (child.tagName === 'H3') {
      if (current) items.push(current);
      current = { question: child, answer: [] };
    } else if (current) {
      current.answer.push(child);
    }
  });
  if (current) items.push(current);

  faq.innerHTML = '';

  items.forEach(function(item) {
    var faqItem = document.createElement('div');
    faqItem.className = 'faq-item';

    item.question.classList.add('faq-question');
    faqItem.appendChild(item.question);

    var answerDiv = document.createElement('div');
    answerDiv.className = 'faq-answer';
    item.answer.forEach(function(el) { answerDiv.appendChild(el); });
    faqItem.appendChild(answerDiv);

    item.question.addEventListener('click', function() {
      faqItem.classList.toggle('active');
    });

    faq.appendChild(faqItem);
  });
});
